import './UpdatedContent.css';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { IoClose } from 'react-icons/io5';
import { HiMiniArrowLongLeft, HiMiniArrowLongRight } from 'react-icons/hi2';
import { useDisplayWidgetContext } from '../../DisplayWidget/utils/context';
import HotspotMedia from '../../../common/ImageHotspot/HotspotMedia';
import { FaRegHeart } from 'react-icons/fa';
import { addUTMToURL, calculatePrice, getCurrentSymbol, PriceDisplay } from '../../../Helpers/Helpers';

dayjs.extend(relativeTime);

export default function UpdatedContent(props) {
  const { activeIndex, setActiveIndex, onClose } = props;
  const { data, albumData, layout, isGoogle, shopifyData } = useDisplayWidgetContext();
  return (
    <idk-div class="modal_container">
      <idk-span class="modal_close_btn" onClick={() => onClose()}>
        <IoClose size={24} color="#928b80" />
      </idk-span>
      <idk-p class="modal_username">@{albumData[activeIndex]?.username}</idk-p>
      <idk-div class="modal_relative_time zid-flex zid-items-center zid-justify-between">
        {dayjs(albumData[activeIndex]?.timestamp).fromNow()}
        <idk-div class="zid-flex zid-items-center zid-gap-1 zid-text-[#423b2fbf]">
          <FaRegHeart size={18} color="#423b2fbf" /> {albumData[activeIndex]?.likes}
        </idk-div>
      </idk-div>
      <idk-div class="modal_content">
        <idk-div class="modal_image">
          <HotspotMedia
            layout={layout}
            autoPlay={layout?.popupSettings?.popupVideoAutoPlay}
            isMuted={layout?.popupSettings?.popupVideoMute}
            showMute={true}
            playFunctionality={true}
            row={albumData[activeIndex]}
            isModal={true}
            backgroundBlur={true}
            style={{
              height: '100%',
              width: '100%',
              objectFit: 'contain',
              maxHeight: isGoogle ? '90vh' : '100%',
            }}
          />
        </idk-div>
        {albumData[activeIndex].products?.length > 0 && (
          <idk-div class="modal_product">
            <idk-div class="modal_product_inner zid-flex zid-flex-col zid-items-center">
              <idk-p class="modal_product_title">{albumData[activeIndex].products[0]?.title}</idk-p>
              <idk-div class="modal_product_image">
                <img
                  src={
                    albumData[activeIndex].products[0]?.image ||
                    albumData[activeIndex].products[0]?.images?.[0]?.src ||
                    albumData[activeIndex].products[0]?.variants?.[0]?.featured_image?.src ||
                    albumData[activeIndex].products[0]?.variants?.[0]?.featured_media?.preview_image?.src
                  }
                  alt={
                    albumData[activeIndex].products[0]?.title ||
                    albumData[activeIndex].products[0]?.variants?.[0]?.featured_image?.alt ||
                    'Product image'
                  }
                />
              </idk-div>
              <idk-div class="modal_product_price">
                {shopifyData ? (
                  <idk-div
                    class={`${
                      albumData[activeIndex].products[0]?.variants?.[0]?.compare_at_price >
                      albumData[activeIndex].products[0]?.variants?.[0]?.price
                        ? 'zid-discounted-price'
                        : 'zid-regular-price'
                    }`}
                  >
                    {layout?.productsSettings?.currencySymbol
                      ? layout?.productsSettings?.currencySymbol
                      : shopifyData?.currency?.active &&
                        getCurrentSymbol(shopifyData?.currency?.active, shopifyData?.locale)}
                    {calculatePrice(
                      parseFloat(albumData[activeIndex].products[0]?.variants?.[0]?.price) / 100,
                      parseFloat(shopifyData?.currency?.rate),
                    )}
                  </idk-div>
                ) : (
                  <PriceDisplay
                    price={albumData[activeIndex].products[0]?.variants?.[0]?.price}
                    salePrice={albumData[activeIndex].products[0]?.variants?.[0]?.salePrice}
                    currency={data.result.currency}
                    staticCurrency={layout?.productsSettings?.currencySymbol}
                    discountPriceOnRight={layout?.productsSettings?.showDiscountPriceOnRight}
                  />
                )}
              </idk-div>
              <button
                onClick={() => {
                  window.open(
                    shopifyData
                      ? addUTMToURL(
                          `https://${window.location.host}/products/${albumData[activeIndex].products[0]?.handle}`,
                          {
                            utm_source: layout?.gallerySettings?.utmSource,
                            utm_medium: layout?.gallerySettings?.utmMedium,
                            utm_campaign: layout?.gallerySettings?.utmCampaign,
                          },
                        )
                      : `${albumData[activeIndex].products[0]?.product_url}?utm_source=${
                          layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                        }&utm_medium=${layout?.gallerySettings?.utmMedium || 'AddToCart'}&utm_campaign=${
                          layout?.gallerySettings?.utmCampaign || 'ShoppableVideosHomepage'
                        }`,
                    '_blank',
                  );
                }}
                className="idk-product-shop-btn"
              >
                Shop this product
              </button>
            </idk-div>
          </idk-div>
        )}
        <idk-span
          class="modal_arrow_btn left_arrow"
          onClick={() => {
            if (activeIndex > 0) {
              setActiveIndex(activeIndex - 1);
            }
          }}
        >
          <HiMiniArrowLongLeft size={24} color="#928b80" />
        </idk-span>
        <idk-span
          class="modal_arrow_btn right_arrow"
          onClick={() => {
            if (activeIndex < albumData.length - 1) {
              setActiveIndex(activeIndex + 1);
            }
          }}
        >
          <HiMiniArrowLongRight size={24} color="#928b80" />
        </idk-span>
      </idk-div>
    </idk-div>
  );
}
